import { render, staticRenderFns } from "./DriverInvoice.vue?vue&type=template&id=64f4fd3f"
import script from "./DriverInvoice.vue?vue&type=script&lang=js"
export * from "./DriverInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports